import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaStyleUtility from "global/sparta-style-utility";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaStoreUtility from "global/sparta-store-utility";
import "global/sparta-global-data-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaMediaQueryUtility from "global/sparta-mediaquery-utility";










const classDefaults = {
    debug: false,
    evtNamespace: 'spaUILayer',
    closeLayerNameSpace: 'info-layer-evt',
    initNamespace: 'sparta-ui-layers-utility',
    scrollNamespace: 'scrollfix',
    globalReady: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
    globalReadyToken: '',
    layerClass: 'spa-ui-layer',
    linkClass: 'spa-ui-layer-link',
    closeClass: 'spa-ui-layer-close',
    openClass: 'spa-ui-layer-opened',
    adaLayerID: 'SpartaUILayer',
    adaCloseID: 'Close',
    modalLayerClass: 'spa-ui-modal',
    infoLayerClass: 'spa-ui-info',
    layerLinkOffset: 8, 
    nextZIndex: 1001,
    continueLinkPostfixID: 'ContinueLink',
    backLinkPostfixID: 'BackLink',
};


const linkDefaults = {
    type: null, 
    width: null, 
    layerId: null,
    layerCloseId: null,
    layerEndId: 'spaLayerEnd',
    layerClass: 'spa-ui-layer',
    optionalClasses: '',
    onOpen: '', 
    onClose: '', 
    closeButton: true, 
    closeTriggers: [], 
    closeOnEscape: true, 
    closeAdaText: ' Layer',
    closeAdaTextSpacer: ': ',
    closeAdaTextOverride: '',
    interstitialType: '',
    adaCloseFocus: false, 
    interstitialBranding: 'default',
    targetAction: '',
    modalLayer: {
        class: classDefaults.modalLayerClass,
        width: 600,
    },
    infoLayer: {
        class: classDefaults.infoLayerClass,
        layerAdjustTop: 10,
        layerAdjustLeft: 10,
        width: {
            small: {
                chars: 350,
                width: 250,
                class: `${classDefaults.infoLayerClass}-small`,
            },
            medium: {
                chars: 800,
                width: 400,
                class: `${classDefaults.infoLayerClass}-medium`,
            },
            large: {
                chars: 0,
                width: 400,
                class: `${classDefaults.infoLayerClass}-large`,
            },
            default: {
                width: 250,
                class: `${classDefaults.infoLayerClass}-large`,
            },
        },
    },
};

const EVENTS = {
    MODAL_OPENED: "MODAL_OPENED.spartaUILayersUtility",
    MODAL_CLOSED: "MODAL_CLOSE.spartaUILayersUtility",
    FREEZE_SCROLL: "FREEZE_SCROLL.spartaUILayersUtility",
    UNFREEZE_SCROLL: "UNFREEZE_SCROLL.spartaUILayersUtility",
};


const options = {
    debug: false,
    $applicationContainer: undefined,
    $body: $('body'),
    $html: $('html'),
    $window: $(window),
    $document: $(document),
    $context: undefined,
};





class SpartaUILayersUtility {





    constructor() {

        this.options = Object.assign({}, classDefaults, options);

        this.options.globalReadyToken = spartaEventsUtility.sub(`${this.options.globalReady}`, this._addListeners.bind(this));


        this.options.windowWidth = this.options.$window.width();
    }

    get EVENTS() {
        return EVENTS;
    }






    _addListeners() {

        this.options.$applicationContainer = $(spartaStoreUtility.getData("applicationContainer"));

        spartaEventsUtility.unsubByToken(this.options.globalReadyToken);

        this.options.$applicationContainer.on(`click.${this.options.evtNameSpace}`, `.${this.options.linkClass}`, this._onLayerLinkClick.bind(this));

        this.options.$applicationContainer.on(`animationend.${this.options.evtNamespace} oAnimationEnd.${this.options.evtNamespace} webkitAnimationEnd.${this.options.evtNamespace}`, this._infoLayerAnimationEnd.bind(this));
    }







    displayPopup(url, windowName, args = 'width=750,height=450,resizable,scrollbars') {
        let defaultArgs = $.extend({}, args);
        const newWindow = window.open(url, windowName, args);
        newWindow.focus();

        return false;
    }




    addPopupWindowHelper(elements) {
      let popupElements = Array.prototype.slice.call(elements, 0);

      popupElements.forEach(elem => {
        elem.addEventListener('click', ((event) => {
          event.preventDefault();

          let args = '';
          const $elem = $(elem);
          const defaults = {
            block      : false,
            height     : 600,
            href       : $elem.attr('href'),
            menubar    : false,
            scrollbars : true,
            size       : null,
            status     : false,
            width      : 400,
            windowName : 'spawin',
            x          : 0,
            y          : 0,
          };
          const options = Object.assign({}, defaults, ($elem.data('options') || {}));
          const sizes = {
            large  : { height: 600, width: 800 },
            medium : { height: 400, width: 600 },
            small  : { height: 200, width: 300 },
          };

          if (options.size) {
            options.width = sizes[options.size].width;
            options.height = sizes[options.size].height;
          }



          options.y = Math.floor((screen.availHeight - (options.height || screen.height)) / 2) - (screen.height - screen.availHeight);
          options.x = Math.floor((screen.availWidth - (options.width || screen.width)) / 2) - (screen.width - screen.availWidth);


          if (!options.block) {
            args = `${args}width=${options.width},height=${options.height},left=${options.x},top=${options.y},status=${options.status},scrollbars=${options.scrollbars},menubar=${options.menubar}`;
          }

          this.displayPopup(options.href, options.windowName, args);

          elem.classList.add('force-visited');
          return false;
        }));
      });
    }







    _onLayerLinkClick(event) {
        let $this = $(event.currentTarget);

        this.openLayer($this, event);
    }







    _infoLayerAnimationEnd(e) {
        const $target = $(e.target);


        if ($target.hasClass('spa-ui-animate-fadeOutUp') || $target.hasClass('spa-ui-animate-fadeOutDown')) {
            $target.hide();
        }
    }









    _setLayerOptions(linkSpecificSettings = {}, contentOptions = {}, linkOptions = {}) {
        return Object.assign({}, linkDefaults, linkSpecificSettings, contentOptions, linkOptions);
    }









    openLayer(obj, e) {
        const event = e || {};

        let $obj = obj;
        let linkOptions = {};

        let $layer;
        let $link;
        let $content;
        let contentId;
        let contentOptions;


        if (event.type) {
            event.preventDefault();
        }


        if ($obj && !$obj.jquery) {
            $obj = $(obj);
        }


        if (!$obj || !$obj.length) {
            this._debug('Error: spartaUILayer: Nothing passed in');

            return false;
        }


        this.options.$applicationContainer = event.$applicationContainer || $(spartaStoreUtility.getData("applicationContainer"));


        if ($obj.hasClass(this.options.linkClass)) {
            $link = $obj;

            linkOptions = $link.data('options') || {};
            contentId = $link.attr('rel');


            if (linkOptions.interstitialType) {
                linkOptions.type = "modal";
                contentId = linkOptions.rel || `${linkOptions.interstitialType}-${linkOptions.interstitialBranding || "default"}`;
            }

            $content = $(`#${contentId}`) || null;
        } else {
            $content = $obj;
            $link = this.options.$applicationContainer;
            contentId = $content.attr('id');
        }

        contentOptions = $content.data('options') || {};


        const linkSpecificSettings = {
            closeText: spartaGlobalFunctions.getGlobalParams('closeTest') || 'close',
            $content: $content,
            contentId: contentId,
            returnFocusToLink: event.currentTarget ? $(event.currentTarget) : this.options.$applicationContainer,
            position: {
                browserWidth: this.options.$body.width(),
                applicationWidth: this.options.$applicationContainer.width(),
                activeMouseTop: event.pageY,
                activeMouseLeft: event.pageX,
                linkWidth: $link.width(),
                linkHeight: $link.height(),
                linkOffsetTop: $link.offset().top,
                linkOffsetLeft: $link.offset().left,
                screenTop: this.options.$document.scrollTop(),
            },
        };





        const o = this._setLayerOptions(linkSpecificSettings, contentOptions, linkOptions);


        if (typeof o.$content === 'undefined') {
            o.$content = $('#' + o.contentId);


            if (typeof o.$content === 'undefined' && typeof o.interstitialType === 'undefined') {
                this._debug('cannot find: ' + o.contentId);

                return false;
            }
        }


        o.layerId = `${o.contentId}${this.options.adaLayerID}`;
        o.layerCloseId = `${o.layerId}${this.options.adaCloseID}`;


        switch(o.type) {
            case 'modal':
                $layer = this._openModalLayer(o, $layer, $link);

                this.options.$applicationContainer.addClass('spa-ui-modal-open');

                break;
            case 'info':
                $layer = this._openInfoLayer(o, $layer, $link);

                this.options.$applicationContainer.addClass('spa-ui-tooltip-open');

                break;
            default:
                return false;
        }



        let $modalElement = $layer.find('.spa-content');
        let $contentDiv = $modalElement.find('.content');
        let contentDiv = $contentDiv[0];
        let originalWindowWidth = this.options.$window.width();
        const resizeContentBody = function (event) {
            if (!contentDiv) {
                return false;
            }

            let contentBodyChanged = false;


            let origMaxHeight = parseInt(contentDiv.getAttribute("data-orig-max-height"));
            if (!origMaxHeight) {
                origMaxHeight = parseInt(window.getComputedStyle(contentDiv).maxHeight);
                contentDiv.setAttribute("data-orig-max-height", origMaxHeight);
            }


            if ($modalElement[0].scrollHeight > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {
                let amountToReduce = $modalElement[0].scrollHeight - Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                contentDiv.style.maxHeight = contentDiv.offsetHeight - amountToReduce - 25 + "px";
                contentBodyChanged = true;
            } else {

                let amountToIncrease = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - $modalElement[0].scrollHeight;
                if (contentDiv.offsetHeight + amountToIncrease > origMaxHeight) {
                    contentDiv.style.maxHeight = origMaxHeight + "px";
                } else if (amountToIncrease > 0) {
                    contentDiv.style.maxHeight = contentDiv.offsetHeight + amountToIncrease - 25 + "px";
                }

                contentBodyChanged = true;
            }


            if (contentBodyChanged) {
              $contentDiv.trigger('scroll.uilayer_content');
            }
        }


        if (contentDiv) {
          resizeContentBody.call(this);

          this.options.$window.on('resize.closeModal orientationchange.closeModal', resizeContentBody.bind(this));
        }

        $layer.data('type', o.type);

        if (o.returnFocusToLink && o.returnFocusToLink[0] && o.returnFocusToLink[0].id) {
          $layer.data('returnFocusToLink', `#${o.returnFocusToLink[0].id}`);
        } else {
          $layer.data('returnFocusToLink', `body`);
        }

        $layer.data('contentId', o.contentId);


        const $closeButton = $layer.find(`.${this.options.closeClass}`);


        $closeButton.focus();


        const _closeLayer = function () {
            this.closeLayer($layer);


            this.options.$body.off(`keydown.${this.options.evtNamespace}`);
        }

        $closeButton.off(`click.${this.options.evtNamespace}`).on(`click.${this.options.evtNamespace}`, _closeLayer.bind(this));


        if (o.closeOnEscape) {
            const _closeLayerOnEscape = function (event) {
                if (event.keyCode === 27) {
                    this.closeLayer($layer);


                    this.options.$body.off(`keydown.${this.options.evtNamespace}`);
                }
            };

            this.options.$body.on(`keydown.${this.options.evtNamespace}`, _closeLayerOnEscape.bind(this));
        }


        if (o.closeTriggers && o.closeTriggers.length > 0) {
            $(o.closeTriggers).each(function (i, e) {
                const $link = $layer.find(e);

                const _closeLayerWithTriggers = function () {
                    this.closeLayer($layer);
                };

                $link.click(_closeLayerWithTriggers.bind(this));
            }.bind(this));
        }

        if ((o.onOpen && o.onOpen.length > 0) && (o.onClose && o.onClose.length > 0)) {
            this._deprecated("onOpen/onClose method is no longer supported - please use spartaEventUtilitys and spartaEventUtility.MODAL_OPENED/MODAL_CLOSED");
        }


        let addContent = function (content) {
            $layer.find(".site-specific-placeholder-content").html(content);
            resizeContentBody.call(this);
        };


        o.returnFocusToLink.addClass(this.options.openClass);


        spartaEventsUtility.pub(EVENTS.MODAL_OPENED, {
            type: o.type,
            contentId: o.contentId,
            layer: $layer,
            addContent: addContent,
        });

        $layer.attr('aria-hidden', false);
    }











    closeLayer(layer) {

        let $layer = (typeof layer === "undefined") ? $(`.${this.options.layerClass}`) : ((typeof layer === "string") ? this.options.$applicationContainer.find(`#${layer}`).slice(0,1) : $(layer));


        if ($layer.length === 0) {
            return;
        }

        let _onEachItem = function (origLayer, index, element) {
            const $this = $(element);

            const o = $this.data() || {};

            let layerType = "";
            let $returnFocusToLink = o.returnFocusToLink;
            let isCurrentlyShowing = ($this.css('display') !== "none");


            if (!isCurrentlyShowing) return;


            if ($layer.length === 1) {

                if(!($returnFocusToLink instanceof $)) {
                    $returnFocusToLink = this.options.$applicationContainer.find($returnFocusToLink).slice(0,1);
                }

                if ($returnFocusToLink.length && $returnFocusToLink.is(':visible')) {
                    $returnFocusToLink
                        .removeClass(this.options.openClass)
                        .focus();
                } else {
                    this.options.$applicationContainer.focus();
                }
            }


            if ($this.hasClass(this.options.modalLayerClass)) {
                this._closeModalLayer($this);
            } else if ($this.hasClass(this.options.infoLayerClass)) {
                this._closeInfoLayer($this);
            }




            spartaEventsUtility.pub(EVENTS.MODAL_CLOSED, {
                eventType: EVENTS.MODAL_CLOSED,
                type: o.type,
                contentId: o.contentId,
                layer: $layer,
            });

            $this.data('returnFocusToLink', null);

            $this.attr('aria-hidden', true);

            this._bodyUnfreezeScroll($this);

            this.options.$applicationContainer.removeClass('spa-ui-tooltip-open spa-ui-modal-open');
        };


        $layer.each(_onEachItem.bind(this, layer));

        this.options.$body.off(`click.${this.options.closeLayerNameSpace}`);
    }







    _bodyFreezeScroll($layer) {
        if ($layer.length) {
            let browserObject = spartaStoreUtility.getData("browser");
            let currentMQ = spartaStoreUtility.getData("currentMQ");


            this.options.$applicationContainer.find("#top").css("margin-top", (-1 * this.options.$document.scrollTop()));
            this.options.$document.scrollTop(0);
            this.options.$body.addClass('spa-ui-freeze-scroll');


            spartaEventsUtility.pub(EVENTS.FREEZE_SCROLL);
        }
    }







    _bodyUnfreezeScroll($layer) {
        if ($layer.length && this.options.$body.hasClass('spa-ui-freeze-scroll')) {

            this.options.$body.removeClass('spa-ui-freeze-scroll');

            let browserObject = spartaStoreUtility.getData("browser");
            let currentMQ = spartaStoreUtility.getData("currentMQ");


            let topElement = $(this.options.$applicationContainer.find("#top")[0]);
            let scrollPosition = parseInt(topElement.css("margin-top"));
            topElement.css("margin-top", 0);
            this.options.$document.scrollTop(-1 * scrollPosition);

            spartaEventsUtility.pub(EVENTS.UNFREEZE_SCROLL);
        }
    }






    _closeModalLayer($layer) {
        $layer.css('display', 'none');

        let $spaContent = $layer.find('.content');
        $spaContent[0].scrollTop = 0;
        let $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

        if ($alphaLayer) {
            $spaContent.off('scroll.uilayer_content');
        }
    }







    _closeInfoLayer($layer) {
        if ($layer.hasClass('spa-ui-animate-fadeInDown')) {
            $layer
                .removeClass('spa-ui-animate-fadeInDown')
                .addClass('spa-ui-animate-fadeOutUp')
            ;
        } else if($layer.hasClass('spa-ui-animate-fadeInUp')) {
            $layer
                .removeClass('spa-ui-animate-fadeInUp')
                .addClass('spa-ui-animate-fadeOutDown')
            ;
        }

        let $spaContent = $layer.find('.content');
        $spaContent[0].scrollTop = 0;
        let $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

        if ($alphaLayer) {
            $spaContent.off('scroll.uilayer_content');
        }
    }








    _getNextZindex(o) {
        return this.options.nextZIndex++;
    }
















    _formatCloseLink(o) {
        let _updateAdaCloseLink = function (s) {
            if (s) {
                o.closeAdaText += o.closeAdaTextSpacer + s;
            }
        };

        if (o.closeAdaTextOverride) {
            _updateAdaCloseLink(o.closeAdaTextOverride);
        } else if (o.$content.find('h3').length > 0) {
            _updateAdaCloseLink(o.$content.find('h3:first').text());
        } else if (o.$content.find('h2').length > 0) {
            _updateAdaCloseLink(o.$content.find('h2:first').text());
        } else if (o.$content.find('h4').length > 0) {
            _updateAdaCloseLink(o.$content.find('h4:first').text());
        } else if (o.$content.find('.ada-title').length > 0) {
            _updateAdaCloseLink(o.$content.find('.ada-title').text());
        } else if (o.returnFocusToLink.length > 0 && o.returnFocusToLink.text().length > 0) {
            _updateAdaCloseLink(o.returnFocusToLink.text().replace(/layer/g, ""));
        } else if (o.$content.find('p').length > 0) {
            _updateAdaCloseLink(o.$content.find('p:first').text().substr(0, 50));
        } else {
            _updateAdaCloseLink();
        }
    }

















    _getLayerPos($layer, $link) {

        const link = $link[0].getBoundingClientRect();


        const viewport = {
            width: this.options.$window.width(),
            height: this.options.$window.height(),
        };


        const layer = {
            width: $layer.width(),
            height: $layer.height(),
        };

        const center = this._getLinkCenter(link);


        return {
            x: this._getLayerX(link, layer, viewport),
            y: this._getLayerY(link, layer, viewport),
            center,
        };
    }








    _getLinkCenter(link) {
        return link.left + (link.width / 2);
    }













    _getLayerY(link, layer, viewport) {

        return (link.bottom >= layer.height) ? -1 : 1;
    }
















    _getLayerX(link, layer, viewport) {
        const center = this._getLinkCenter(link);


        let x = 0;

        if (layer.width >= viewport.width) {

            x = 3;
        } else if ((layer.width >= link.right) && (layer.width >= viewport.width - link.left)) {

            x = 2;
        } else if (viewport.width - link.left >= layer.width) {

            x = -1;
        } else if (link.right - layer.width >= 0) {

            x = 1;
        }

        return x;
    }










    _openModalLayer(o, $layer, $link) {

        this.closeLayer();



        let _widthValue = o.width || o.modalLayer.width;

        $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0,1);


        if ($layer.length > 0) {

            if (o.interstitialType) {
              $layer.find('.spa-body').html(this._generateInterstitialContentHTML(o, $link));
            }

            $layer.removeClass('full-width');
            $layer.css('display', 'block');
        } else {

            this._formatCloseLink(o);


            const modalLayerElement = document.createElement('div');
            modalLayerElement.id = o.layerId;
            modalLayerElement.style.zIndex = this._getNextZindex(o);

            let htmlOptions = {
                widthValue: _widthValue,
            };
            let spaBody = '';

            let lang = (spartaStoreUtility.getData("lang") === "en-us" ? "en" : "es");
            let branding = o.interstitialType && o.interstitialType.length > 0 ? o.interstitialBranding : o.branding;
            let spaParams = spartaStoreUtility.getData('spaParams');

            if (branding) {
                htmlOptions.customHeaderStyles = {
                    "background-image": `url('${spaParams.global[lang].layers.modalHeaderBackgrounds[branding]}')`
                };
                o.optionalClasses += (o.optionalClasses && o.optionalClasses.length > 0 ? ' ' : '') + 'spa-ui-modal-interstitial';
                o.interstitialBranding = branding;
            }


            if (o.interstitialType) {
                spaBody = this._generateInterstitialContentHTML(o, $link, modalLayerElement);
            } else {
                this._addClassesToElement(modalLayerElement, [o.layerClass, o.modalLayer.class].concat(o.optionalClasses.split(" ")));

                spaBody = (o.$content instanceof $ ? o.$content.detach().removeClass('hide') : o.$content);
            }


            const modalLayerHTML = this._generateModalHTML(o, htmlOptions);
            modalLayerElement.innerHTML = modalLayerHTML;
            this.options.$applicationContainer.append(modalLayerElement);

            let newModal = this.options.$applicationContainer.find(`#${modalLayerElement.id}`);
            if (spaBody instanceof $) {
              spaBody.appendTo(newModal.find(".spa-body"));
            } else {
              newModal.find(".spa-body").append(spaBody);
            }
        }


        this._updateLinksDataCollection();

        $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0,1);


        this._bodyFreezeScroll($layer);
        this._addAlphaLayer($layer.find('.spa-body'));


        let $modalDialog = $layer.find('.spa-dialog');
        let _layerWidth = $modalDialog.width();


        if (o.position.browserWidth <= _layerWidth) {
            $modalDialog.addClass('full-width');
        }


        let closeModal = function (event) {
            this.options.$window.off('resize.closeModal orientationchange.closeModal');
            this.closeLayer(o.layerId);
        }
        this.options.$applicationContainer.find('.close-interstitial.spa-btn').off('click').on('click', closeModal.bind(this));


        let $closeButton = $modalDialog.find(`#${o.layerCloseId}`);
        let $layerEnd = $modalDialog.find(`#${o.layerEndId}`);
        $modalDialog.on(`keydown.${this.options.evtNamespace}`, function (event) {
            if (event.keyCode === 9) {
                let $target = $(event.target);


                if (!event.shiftKey && $target.is($layerEnd)) {
                    $closeButton.focus();

                    return false;


                } else if (event.shiftKey === true && $target.is($closeButton)) {
                    $layerEnd.focus();

                    return false;
                }
            }
        });

        return $layer;
    }









    _generateModalHTML(o, htmlOptions) {
        let customHeaderStyles = "";

        if (htmlOptions.customHeaderStyles) {
            _.each(htmlOptions.customHeaderStyles, (value, key) => {
                customHeaderStyles += `${key}:${value};`;
            })
        }

        const modalHTML = `
            <div class="spa-dialog" style="z-index: ${this._getNextZindex(o)}; width: ${htmlOptions.widthValue}px;">
                <div class="spa-content">
                    <div class="spa-header${(o.interstitialBranding ? ` ${o.interstitialBranding}` : '')}"${customHeaderStyles ? ` style="${customHeaderStyles})"` : ``}>
                        <a id="${o.layerCloseId}" class="spa-ui-layer-close svg-button${((o.interstitialType || o.adaCloseFocus) ? ' svg-button--dark-bg close-interstitial' : '')}${(!o.closeButton ? ' hide' : '')}" href="javascript:void(0);">
                            <span class="ada-hidden">${o.closeText}${o.closeAdaText}</span>
                            <span class="spa-close-x" aria-hidden="true">×</span>
                        </a>
                    </div>
                    <div class="spa-body"></div>
                    <div id="${o.layerEndId}" tabindex="0" class="ada-hidden">End of layer.</div>
                </div>
            </div>
        `;

        return modalHTML;
    }








    _addAlphaLayer($baseLayer) {
        let $spaBody = $baseLayer.hasClass('spa-body') ? $baseLayer : $baseLayer.find('.spa-body');
        const $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

        if ($alphaLayer.length) {
            $alphaLayer.remove();
        }

        $baseLayer.append('<div class="spa-content-alpha-layer"></div>');


        if ($spaBody.find('.content').length === 0) {
          return false;
        }


        let myInterval = setInterval(function () {
            let newHeight = $spaBody.find('.content')[0].scrollHeight;
            this._showHideAlphaOverlay($spaBody.find('.content')[0], $spaBody.find('.spa-content-alpha-layer'));

            if (newHeight && newHeight > 0) {
                clearInterval(myInterval);


                let $spaContent = $baseLayer.find('.content');
                let $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

                if ($alphaLayer) {
                    if ($spaContent[0].scrollHeight > $spaContent[0].clientHeight) {
                        $alphaLayer.css('display', 'block');
                    }

                    $spaContent
                        .on('scroll.uilayer_content', function (event) {
                            this._showHideAlphaOverlay(event.currentTarget, $alphaLayer);
                        }.bind(this));
                }
            }
        }.bind(this), 10);
    }









    _showHideAlphaOverlay(currentTarget, $alphaLayer) {
        let displayValue = 'none';


        let alphaLayerHeight = 40;


        if (currentTarget.scrollHeight > alphaLayerHeight) {

            if (currentTarget.scrollTop + currentTarget.clientHeight < currentTarget.scrollHeight) {
                displayValue = "block";
            }
        }

        $alphaLayer.css('display', displayValue);
    }










    _openInfoLayer(o, $layer, $link) {

        let _widthValue;
        let _sizeClass;
        let _zIndex;


        this.closeLayer();

        $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

        if (!$layer.find('.spa-layer-content').length) {

            let _contentLength = o.$content.find(' > :not(".ada-hidden")').text().replace(/  /g, '').length;

            if (_contentLength < o.infoLayer.width.small.chars) {
                _widthValue = o.infoLayer.width.small.width;
                _sizeClass = o.infoLayer.width.small.class;
            } else if (_contentLength < o.infoLayer.width.medium.chars) {
                _widthValue = o.infoLayer.width.medium.width;
                _sizeClass = o.infoLayer.width.medium.class;
            } else {
                _widthValue = o.infoLayer.width.large.width;
                _sizeClass = o.infoLayer.width.large.class;
            }


            this._formatCloseLink(o);


            const infoLayerElement = document.createElement('div');

            _zIndex = this._getNextZindex(o);

            infoLayerElement.id = o.layerId;
            infoLayerElement.style.zIndex = _zIndex;
            this._addClassesToElement(infoLayerElement, [o.layerClass, o.infoLayer.class, _sizeClass]);

            const infoLayerHTML = `
                <div class="spa-layer-content" role="dialog" aria-labelledby="${o.contentId}_title">
                    <div class="spa-content">
                        <div class="spa-header">
                            <a id="${o.layerCloseId}" class="spa-ui-layer-close svg-button" href="javascript:void(0);">
                                <span class="ada-hidden">${o.closeText}${o.closeAdaText}</span>
                                <span class="spa-close-x" aria-hidden="true">×</span>
                            </a>
                        </div>
                        <div class="spa-body"></div>
                        <div id="${o.layerEndId}" class="ada-hidden">End of layer.</div>
                    </div>
                </div>
            `;

            const layerContent = o.$content.removeClass('hide').detach();

            infoLayerElement.innerHTML = infoLayerHTML;

            this.options.$applicationContainer.append(infoLayerElement);

            $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

            $layer
                .data('linkElement', $link[0].id)
                .find('.spa-body')
                    .append(layerContent)
            ;
        } else {
            if ($layer.hasClass('spa-ui-animate-fadeOutUp') || $layer.hasClass('spa-ui-animate-fadeOutDown')) {
                $layer.show();
            }
        }


        const layerPosition = this._getLayerPos($layer, $link);


        $layer
            .removeClass('spa-ui-info-modal spa-ui-animate-fadeOutUp spa-ui-animate-fadeOutDown')
            .css({
                left: 'inherit',
                top: 'inherit',
            })
        ;


        if (window.matchMedia(spartaMediaQueryUtility.mediaQueries[1].mediaQuery).matches && layerPosition.x !== 3) {
            let appBoundingRect = this.options.$applicationContainer[0].getBoundingClientRect();
            let layerWidth = $layer.width();
            let newLeft = this._getElementPosition($link);
            let newRight = undefined;


            if (layerPosition.x === 0) { 
                newLeft = (layerPosition.center - ($layer.outerWidth() / 2)) - appBoundingRect.left;
            } else if (layerPosition.x === 1) { 
                newLeft = newLeft - $layer.outerWidth() + $link.outerWidth();
            } else if (layerPosition.x === 2) {
                newLeft = (appBoundingRect.right - $layer.outerWidth()) / 2;
            }

            $layer.css({
                left: `${newLeft}px`,
                right: `${newRight}px`,
                width: `${layerWidth}px`,
            });


            if (layerPosition.y === -1) { 
                let newTop = $link[0].getBoundingClientRect().top - appBoundingRect.top - $layer.outerHeight() - this.options.layerLinkOffset;
                let layerHeight = $layer.outerHeight();

                $layer
                    .css({
                        top: `${newTop}px`,
                        height: `${layerHeight}px`,
                    })
                    .addClass('spa-ui-animate-fadeInUp')
                ;
            } else if (layerPosition.y === 1) { 
                let newTop = this._getElementPosition($link, "top");

                $layer
                    .css('top', `${newTop + $link.outerHeight() + this.options.layerLinkOffset}px`)
                    .addClass('spa-ui-animate-fadeInDown')
                ;
            }
        } else {
            $layer.css({
                left: '0px',
                top: '0px',
            });

            $layer.addClass('spa-ui-info-modal');

            if (layerPosition.y === -1) {
                $layer.addClass('spa-ui-animate-fadeInUp');
            } else if (layerPosition.y === 1) {
                $layer.addClass('spa-ui-animate-fadeInDown');
            }

            this._bodyFreezeScroll($layer);


            let $spaContent = $layer.find('.content');
            let contentHeight = document.body.clientHeight -
                ($spaContent.offset().top - $layer.offset().top) -
                parseInt($layer.css("padding-bottom")) -
                parseInt($layer.find(".spa-body").css("padding-bottom"));
            $spaContent.css("max-height", contentHeight + "px");
        }

        this._addAlphaLayer($layer);

        const _closeInfoLayer = function (force = false, e) {
            const width = this.options.$window.width();

            if (width === this.options.windowWidth && !force) {
                if (e) {
                    e.preventDefault();
                }

                return false;
            } else {
                if (!$.contains($layer[0], e.target)) {
                    this.closeLayer(this.options.$applicationContainer('.spa-ui-info').slice(0,1));

                    this.options.$body.off(`click.${this.options.closeLayerNameSpace}`);
                }
            }
        };






        return $layer;
    }









     _addClassesToElement(element, classes) {
        classes.forEach(function (val) {
            if (val && val.length > 0) {
                element.classList.add(val);
            }
        });
    }

    _getElementPosition(element, position) {
        let bodyRect = document.body.getBoundingClientRect();
        let elemRect = element[0].getBoundingClientRect();
        let appRect = this.options.$applicationContainer[0].getBoundingClientRect();

        if (position === "top") {
            return elemRect.top - appRect.top;
        } else {
            return elemRect.left - appRect.left;
        }
    }











    _generateInterstitialContentHTML(o, $link, modalLayerElement = null) {






      if (o.interstitialType != "leaving-site" && o.interstitialType != "language-change" && o.interstitialType != "leaving-and-language") {
          this._debug('Use one of the standard interstitialType values: language-change, leaving-site, leaving-and-language');
      }

      if (o.interstitialBranding != "default" && o.interstitialBranding != "edge" && o.interstitialBranding != "enterprise" && o.interstitialBranding != "co-brand") {
          this._debug('Use one of the standard interstitialBranding values: edge, enterprise, co-brand OR leave this property out of your config completely for a default value of "default"');
      }
      let lang = (spartaStoreUtility.getData("lang") === "en-us" ? "en" : "es");
      let interstitialContent = spaParams.global[lang].layers[o.interstitialType] || {};
      let interstitialGoBackText = interstitialContent.btnText2[o.interstitialBranding] || {};
      let continueLink = $link.attr('href');
      let anchorID = $link.attr('id');

      let classesToAdd = ['spa-ui-modal-interstitial', o.layerClass, o.modalLayer.class];

      if (o.optionalClasses) {
          classesToAdd.concat(o.optionalClasses.split(" "));
      }

      if (modalLayerElement) {
        this._addClassesToElement(modalLayerElement, classesToAdd);
      }

      let contentWrapperId = o.rel || "modalContentInt";

      return `
        <div id="${contentWrapperId}">
          <h3>${interstitialContent.header}</h3>
          <div class="content">
            ${interstitialContent.body}
            <p class="site-specific-placeholder-content"></p>
            <p class="spa-btn-group">
              <a href="${continueLink}" ${(o.targetAction === 'new-tab' ? ' target="_blank"' : '')} id="${anchorID}${classDefaults.continueLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--primary ${(o.targetAction === 'new-tab' ? ' close-interstitial' : '')}">
                ${interstitialContent.btnText1}
              </a>
              <a href="javascript:void(0);" id="${anchorID}${classDefaults.backLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--secondary close-interstitial">
                ${interstitialGoBackText}
              </a>
            </p>
          </div>
        </div>`;
    }






    _updateLinksDataCollection() {
        if (typeof cX === "function") {
            cX('onload');
            this._debug('_updateLinksDataCollection(): cX scan for new links');
        }
    }







    _debug(msg) {
        if (this.options.debug) {
            if (window.console && console.log) {
                console.log('ui-layer debug: ', msg);
            }
        }
    }







    _deprecated(msg) {
        if (this.options.debug) {
            console.error("ui-layer DEPRECATED: " + msg);
        }
    }
}



export default new SpartaUILayersUtility();
